import React, { useState } from 'react';

export default function Onboarding() {
  const [step, setStep] = useState(0);

  const steps = [
    {
      title: "Tu n’es pas seul.",
      text: "Des milliers de personnes ressentent la même chose.\nKindeo est là pour recréer du lien, simplement.",
      button: "Continuer",
    },
    {
      title: "Ici, pas de pression.",
      text: "Pas de likes. Pas de jugement.\nJuste des moments simples, près de chez toi.",
      button: "Je comprends",
    },
    {
      title: "Et si tu essayais ?",
      text: "Un café. Une balade.\nUne vraie discussion.",
      button: "Voir autour de moi",
    },
  ];

  const handleNext = () => {
    if (step < steps.length - 1) {
      setStep(step + 1);
    } else {
      localStorage.setItem('kindeo_onboarding_done', 'true');
      window.location.href = '/carte';
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>{steps[step].title}</h1>
        <p style={styles.text}>
          {steps[step].text.split('\n').map((line, i) => (
            <span key={i}>
              {line}
              <br />
            </span>
          ))}
        </p>

        <button style={styles.button} onClick={handleNext}>
          {steps[step].button}
        </button>

        {step === 2 && (
          <button
            style={styles.secondary}
            onClick={() => {
              localStorage.setItem('kindeo_onboarding_done', 'true');
              window.location.href = '/carte';
            }}
          >
            Plus tard
          </button>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: {
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#F7F9F8',
    padding: 20,
  },
  card: {
    maxWidth: 360,
    textAlign: 'center',
  },
  title: {
    fontSize: 28,
    fontWeight: 800,
    color: '#2D5E4A',
    marginBottom: 20,
  },
  text: {
    fontSize: 16,
    color: '#4A5A52',
    lineHeight: 1.6,
    marginBottom: 40,
  },
  button: {
    width: '100%',
    padding: '14px',
    borderRadius: 30,
    background: '#2D5E4A',
    color: '#fff',
    fontWeight: 700,
    border: 'none',
    cursor: 'pointer',
    marginBottom: 10,
  },
  secondary: {
    background: 'none',
    border: 'none',
    color: '#7A8A82',
    fontSize: 14,
    cursor: 'pointer',
  },
};